import { useMutation } from 'react-query';
import * as authService from '../services/authService';
import { LoginEmailDto, LoginMobileDto, PhoneDto } from '../types/dto';

const sendLoginCode = async (dto: PhoneDto) => {
    return await authService.sendLoginCode(dto);
}

const loginMobile = async (dto: LoginMobileDto) => {
    return await authService.loginMobile(dto);
}


// ++++++++++++++++++++++++++++++++++++++++++++++++++++++
// ++++++++++++++++++++++++++++++++++++++++++++++++++++++


export const useSendLoginCode = (onSuccess: any, onError: any) => {
    return useMutation(sendLoginCode, {
        onSuccess,
        onError
    });
}

export const useLoginMobile = (onSuccess: any, onError: any) => {
    return useMutation(loginMobile, {
        onSuccess,
        onError
    });
}